export const tokenService = {
    login
};

function login(token) {
    sessionStorage.setItem('user', JSON.stringify(token));
}